import { useTranslation } from "react-i18next";
import config from "utils/globals";

const Header = ({ data }) => {
  const { t } = useTranslation();

  const renderTitle = () => {
    return data.get("status") === "SUCCESS"
      ? t("payment.success")
      : t("payment.failed");
  };

  return (
    <div className="flex flex-col justify-center items-center text-gray-4 pb-8 border-b border-gray--7 mt-3">
      <span className="body-16px-regular mb-1">{renderTitle()}!</span>
      <span className="display-demibold">
        {config.numberSeparator(data.get("amount"))}
        <span className="body-16px-regular mr-1">{t("rial")}</span>
      </span>
    </div>
  );
};
export default Header;
